import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'temptik-features',
  templateUrl: './features.component.html',
  styleUrls: ['./features.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeaturesComponent {}
